import React from "react";
import { Storage } from "aws-amplify";
import { Mutation, Query } from "react-apollo";
import { Col, Row, Form, Upload, Button, Icon, Input, message } from "antd";
import { v4 as uuid } from "uuid";

import VerifyCertificate from "../../GraphQL/Mutation/VerifyCertificate";
import UploadCertificate from "../../GraphQL/Mutation/UploadCertificate";
import CertificateList from "../../Components/Orders/CertificateList";
import GetCertificates from "../../GraphQL/Query/GetCertificates";

const FormItem = Form.Item;

class CertificateForm extends React.Component {
  state = {
    cerFile: [],
    keyFile: [],
    cerFileBase64: "",
    keyFileBase64: "",
    password: null,
    uploading: false,
    visible: false
  };

  // Validación del certificado
  handleUpload = async (mutate, uploadMutate, refetch, e) => {
    const { rfc } = this.props;
    const { cerFileBase64, keyFileBase64, password } = this.state;
    e.preventDefault();

    this.setState({
      uploading: true
    });
    mutate({
      variables: {
        params: {
          rfc,
          cerBase64String: cerFileBase64,
          keyBase64String: keyFileBase64,
          keyPassword: password
        }
      }
    })
      .then(data => {
        // console.log(data);
        message.success("¡Certificado válido y vigente!");
        this.handleAdd(data, uploadMutate, refetch);
      })
      .catch(error => {
        // console.log(error);
        message.error(
          "¡Los archivos no corresponden o la contraseña es incorrecta!"
        );
      });

    this.setState({
      uploading: false
    });
  };

  handleAdd = async (validateResponse, uploadMutate, refetch) => {
    const { fieldName, user } = this.props;
    const {
      cerFile: cerSelectedFile,
      keyFile: keySelectedFile,
      password: keyPassword
    } = this.state;
    const {
      data: {
        validateCertificate: { serial, endDate, rfc, type }
      }
    } = validateResponse;
    const visibility = "private";
    const storageOpts = {
      bucket: "as-certificates",
      region: "us-east-1"
    };
    Storage.configure({ ...storageOpts, level: visibility });

    let cerFile, keyFile, cerKey, keyKey;

    // console.log(cerSelectedFile, keySelectedFile);
    if (cerSelectedFile.length) {
      const { name } = cerSelectedFile[0];
      const [, , , extension] = /([^.]+)(\.(\w+))?$/.exec(name);
      cerKey = `${uuid()}${extension && "."}${extension}`;
      cerFile = { ...storageOpts, key: cerKey, identityId: user.id };
    }

    if (keySelectedFile.length) {
      const { name } = keySelectedFile[0];
      const [, , , extension] = /([^.]+)(\.(\w+))?$/.exec(name);
      keyKey = `${uuid()}${extension && "."}${extension}`;
      keyFile = { ...storageOpts, key: keyKey, identityId: user.id };
    }

    const cerType = fieldName === "csd" ? "sello" : "fiel";
    if (type !== cerType) {
      message.error(
        `El tipo de certificado ingresado no corresponde con el requerido.\nIngresaste un certificado de tipo ${type} y se requiere uno de tipo ${cerType}`
      );
      return;
    }

    const uploadReq = {
      serial,
      endDate,
      rfc,
      type,
      cerFile,
      keyFile,
      keyPassword
    };

    console.log(uploadReq);

    try {
      uploadMutate({
        variables: uploadReq
      })
        .then(data => {
          message.success("Certificado guardado correctamente!");
          Storage.put(cerKey, cerSelectedFile[0]);
          Storage.put(keyKey, keySelectedFile[0]);
          if (!this.props.fromProfile) {
            this.props.handleUpload(fieldName, serial);
          }
          this.props.handleUpdate();
          refetch({ type: cerType });
        })
        .catch(error => {
          console.log(error);
          message.error("Error al guardar!");
        });
    } catch (err) {
      console.log(err);
    }
  };

  fileToBase64 = (field, file) => {
    const reader = new FileReader();

    if (!file) {
      this.setState({
        [`${field}Base64String`]: "",
        [`${field}`]: []
      });
      return;
    }

    reader.onload = (theFile => {
      return e => {
        const binaryData = e.target.result;
        const base64String = window.btoa(binaryData);
        // console.log(base64String);
        this.setState({
          [`${field}Base64`]: base64String
        });
      };
    })(file);
    reader.readAsBinaryString(file);
  };

  handleChangePassword = e => {
    const { name, value } = e.target;

    this.setState({ [name]: value });
  };

  render() {
    const {
      uploading,
      keyFileBase64,
      cerFileBase64,
      password,
      visible
    } = this.state;
    const {
      fieldName,
      handleUpload,
      handleUpdate,
      fromProfile,
      label,
      required,
      serialValue
    } = this.props;

    const cerProps = {
      onRemove: file => {
        this.setState(({ cerFile }) => {
          const index = cerFile.indexOf(file);
          const newFileList = cerFile.slice();
          newFileList.splice(index, 1);
          return {
            cerFile: newFileList,
            cerFileBase64: ""
          };
        });
      },
      beforeUpload: file => {
        this.setState(({ cerFile }) => ({
          cerFile: [file]
        }));
        this.fileToBase64("cerFile", file);
        return false;
      },
      fileList: this.state.cerFile
    };

    const keyProps = {
      onRemove: file => {
        this.setState(({ keyFile }) => {
          const index = keyFile.indexOf(file);
          const newFileList = keyFile.slice();
          newFileList.splice(index, 1);
          return {
            keyFile: newFileList,
            keyFileBase64: ""
          };
        });
      },
      beforeUpload: file => {
        this.setState(({ keyFile }) => ({
          keyFile: [file]
        }));
        this.fileToBase64("keyFile", file);
        return false;
      },
      fileList: this.state.keyFile
    };

    const cerType = fieldName === "csd" ? "sello" : "fiel";

    return (
      <Query
        query={GetCertificates}
        fetchPolicy="cache-and-network"
        variables={{ type: cerType }}
      >
        {({ loading, error, data, refetch }) => {
          if (loading) return <p>Loading...</p>;
          if (error) return <p>Error :(</p>;
          const {
            getCertificates: { items: certificates = [] }
          } = data;

          return (
            <div>
              {certificates.length ? (
                <CertificateList
                  certificates={certificates}
                  handleUpload={handleUpload}
                  handleUpdate={handleUpdate}
                  renderForm={() => this.setState({ visible: !visible })}
                  fieldName={fieldName}
                  fromProfile={fromProfile}
                  serialValue={serialValue}
                />
              ) : null}
              {(!certificates.length || visible) && (
                <Mutation mutation={VerifyCertificate}>
                  {mutate => (
                    <Mutation mutation={UploadCertificate}>
                      {uploadMutate => (
                        <Row gutter={32}>
                          <Col span={24} style={{ marginBottom: 16 }}>
                            <h3 style={{ textTransform: "uppercase" }}>
                              {label}
                            </h3>
                            <div
                              style={{
                                color: "var(--color-primary-blue-dark)"
                              }}
                            >
                              {!required
                                ? `El campo ${label} es OPCIONAL, si deseas omitir la carga de tus certificados da clic en el botón de "Siguiente/Terminado" para continuar con tu orden.`
                                : null}
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                            <FormItem
                              label="Certificado"
                              extra="Certificado de la e.firma"
                              required
                            >
                              <Upload
                                {...cerProps}
                                accept="application/x-x509-ca-cert"
                              >
                                <Button size="large">
                                  <Icon type="upload" /> Archivo .cer
                                </Button>
                              </Upload>
                            </FormItem>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                            <FormItem
                              label="Llave"
                              extra="Llave de la e.firma"
                              required
                            >
                              <Upload
                                {...keyProps}
                                accept="application/x-iwork-keynote-sffkey"
                              >
                                <Button size="large">
                                  <Icon type="upload" /> Archivo .key
                                </Button>
                              </Upload>
                            </FormItem>
                          </Col>

                          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                            <FormItem
                              label="Contraseña"
                              extra="Contraseña de llave de la e.firma"
                              required
                            >
                              <Input
                                size="large"
                                name={"password"}
                                type="password"
                                onChange={this.handleChangePassword}
                              />
                            </FormItem>
                          </Col>

                          <Col span={24} style={{ marginBottom: 32 }}>
                            <Button
                              size="large"
                              className="upload-demo-start"
                              type="primary"
                              onClick={e =>
                                this.handleUpload(
                                  mutate,
                                  uploadMutate,
                                  refetch,
                                  e
                                )
                              }
                              disabled={
                                !(cerFileBase64 && keyFileBase64 && password)
                              }
                              loading={uploading}
                            >
                              {uploading
                                ? "Validando y cargando..."
                                : "Validar y guardar"}
                            </Button>
                          </Col>
                          <div className="footer-text">
                            Recurda que tu {label} debe coincidir con tu RFC
                            anteriormente ingresado.
                          </div>
                        </Row>
                      )}
                    </Mutation>
                  )}
                </Mutation>
              )}
            </div>
          );
        }}
      </Query>
    );
  }
}

export default CertificateForm;



// WEBPACK FOOTER //
// ./src/Modules/FormFields/CertificateForm.js